export default "__VITE_ASSET__CNsmMFZf__"